import * as React from "react";
import { CarsHotwireHiddenSearchDataProps } from "components/flexComponents/WizardCarPWA/typings";

export const CarsHotwireHiddenSearchData: React.FunctionComponent<CarsHotwireHiddenSearchDataProps> = ({
  formattedStartDate,
  formattedEndDate,
}) => (
  <div>
    {/* Pickup Date & time  */}
    <input type="hidden" name="start" value={formattedStartDate} data-testid="pickupTime" />
    {/* Dropoff Date & time  */}
    <input type="hidden" name="end" value={formattedEndDate} data-testid="returnTime" />
  </div>
);
